<q9-icon-button
  class="sb-toolbar-actions"
  [icon]="'information-icon'"
  q9Track="TOOLBAR.DIAGRAM_DETAILS"
  matTooltip="{{ 'TOOLBAR.DIAGRAM_DETAILS' | translate }}"
  [matTooltipPosition]="'below'"
  [matMenuTriggerFor]="diagramInfoMenu"></q9-icon-button>

<mat-menu #diagramInfoMenu="matMenu" class="main-bar__diagram-details q9-menu" xPosition="before">
  <div class="diagram-details">
    <p class="diagram-details__label">
      {{ 'TOOLBAR.DIAGRAM_TITLE' | translate }}
    </p>
    <p class="diagram-details__diagram-name">
      {{ diagramData?.name | decodeHtml | textCutterPipe: 80 }}
    </p>
    <p class="diagram-details__label">
      {{ 'TOOLBAR.DIAGRAM_SPACE' | translate }}
    </p>
    <p class="diagram-details__diagram-name">
      {{ diagramData?.team.name | decodeHtml | textCutterPipe: 80 }}
    </p>

    <mat-divider></mat-divider>

    <ng-container *ngIf="mapOwner$ | async as mapOwner">
      <app-diagram-user-details
        [user]="mapOwner"
        [userRole]="'TOOLBAR.DETAILS_MAP_OWNER'"></app-diagram-user-details>

      <mat-divider></mat-divider>
    </ng-container>

    <app-diagram-user-details
      [user]="diagramData?.processOwner"
      [userRole]="'TOOLBAR.DETAILS_OWNER'"></app-diagram-user-details>

    <mat-divider></mat-divider>

    <app-diagram-user-details
      [user]="diagramData?.author"
      [userRole]="'TOOLBAR.DETAILS_AUTHOR'"></app-diagram-user-details>

    <mat-divider></mat-divider>

    <p *ngIf="diagramData?.description" class="diagram-details__label">
      {{ 'TOOLBAR.DIAGRAM_DESCRIPTION' | translate }}
    </p>
    <div class="diagram-details__diagram-description">
      {{ diagramData?.description | decodeHtml }}
    </div>
  </div>
</mat-menu>
